export default function (type, element, _, children) {
  const content = children?.join('')
  if (type === 'paragraph') {
    return `<p class="my-2">${content}</p>`
  }
  if (type === 'o-list-item') {
    return `<li class="list-decimal my-2 ml-8 pl-3">${content}</li>`
  }
  if (type === 'list-item') {
    return `<li class="list-disc my-2 ml-8 pl-3">${content}</li>`
  }
  if (type === 'heading3') {
    return `<h3 class="text-title-h2">${content}</h3>`
  }
  if (type === 'heading4') {
    return `<h4 class="text-title-h3 mt-7">${content}</h4>`
  }
  if (type === 'heading5') {
    return `<h5 class="text-title-h4 mt-5">${content}</h5>`
  }
  if (type === 'hyperlink') {
    const link =
      element.data.url.includes('www.nurole.com') ||
      element.data.url.includes('://nurole.com')
        ? element.data.url.split('nurole.com')[1]
        : element.data.url
    return `<a class="text-red-700 hover:text-red-800 hover:underline active:text-red-900" href=${link}>${content}</a>`
  }
  return null
}
